export enum EventCustom {
    LOGIN = 'LOGIN',
    REGISTER = 'REGISTRAR-USUARIO',
    RECOVER_PASSWORD = 'RECUPERAR-CONTRASENIA',
    OPERATIONS = 'OPERACIONES',
    CHANGES = 'CAMBIOS',
    ACCOUNTS = 'CUENTAS',
    GLOBAL = 'GENERAL'
}
